export default "/fonts/feather.svg?ae7a37fb4445489a72a34dcce26987fd";